import { SnakeCaseValidator } from "./snake-case-validator";
export class LabelValidator {
    snakeCaseValidator;
    constructor() {
        this.snakeCaseValidator = new SnakeCaseValidator();
    }
    validate(trackingData) {
        const label = trackingData.label;
        if (typeof label === 'undefined')
            return;
        this.snakeCaseValidator.validate(label);
    }
}
